import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { AppComponent } from './app.component';
import { SimuladorService } from './datos/simulador.service';
import { ServicioIndicadorCarga } from './libs/ruvpp-angular2-comun/indicador-carga';
import { ServicioAlertas } from './libs/ruvpp-angular2-comun/ServicioAlertas';
import { AbiertoComponent } from './pages/abierto/abierto.component';
import { AdministradorComponent } from './pages/administrador/administrador.component';
import { CatalogoElementosComponent } from './pages/catalogo-elementos/catalogo-elementos.component';
import { CatalogoEspaciosComponent } from './pages/catalogo-espacios/catalogo-espacios.component';
import { CatalogoManoObraComponent } from './pages/catalogo-mano-obra/catalogo-mano-obra.component';
import { CatalogoMaterialesComponent } from './pages/catalogo-materiales/catalogo-materiales.component';
import { CatalogoPrototiposComponent } from './pages/catalogo-prototipos/catalogo-prototipos.component';
import { ExampleComponent } from './pages/example/example.component';
import { LoginComponent } from './pages/login/login.component';
import { MenuComponent } from './pages/menu/menu.component';
import { PortadaSimuladorAdminComponent } from './pages/portada-simulador-admin/portada-simulador-admin.component';
import { PortadaSimuladorComponent } from './pages/portada-simulador/portada-simulador.component';
import { SimuladorComponent } from './pages/simulador/simulador.component';
import { SimuladorPrototiposComponent } from './pages/simulador-prototipos/simulador-prototipos.component';
import { PortadaInicioComponent } from './pages/portada-inicio/portada-inicio.component';

const appRoutes: Routes = [
    { path: '', component: AppComponent, pathMatch: 'full' },
    { path: 'PortadaSimulador', component: PortadaSimuladorComponent },
    { path: 'Login', component: LoginComponent },
    { path: 'PortadaSimuladorAdmin', component: PortadaSimuladorAdminComponent },
    { path: 'Simulador', component: SimuladorComponent },
    { path: 'CatalogoManoObra', component: CatalogoManoObraComponent },
    { path: 'CatalogoMateriales', component: CatalogoMaterialesComponent },
    { path: 'CatalogoElementos', component: CatalogoElementosComponent },
    { path: 'CatalogoEspacios', component: CatalogoEspaciosComponent },
    { path: 'CatalogoPrototipos', component: CatalogoPrototiposComponent },
    { path: 'SimuladorPrototipos', component: SimuladorPrototiposComponent },
    { path: 'PortadaInicioComponent', component: PortadaInicioComponent },
];

@NgModule({
    declarations: [
        AppComponent
        , AbiertoComponent
        , AdministradorComponent
        , LoginComponent
        , ExampleComponent
        , CatalogoManoObraComponent
        , SimuladorComponent
        , PortadaSimuladorComponent
        , CatalogoMaterialesComponent
        , CatalogoElementosComponent
        , MenuComponent
        , PortadaSimuladorAdminComponent
        , CatalogoEspaciosComponent
        , CatalogoPrototiposComponent
        , SimuladorPrototiposComponent
        , PortadaInicioComponent
    ],
    imports: [
        BrowserModule
        , BrowserAnimationsModule
        , FormsModule
        , RouterModule.forRoot(appRoutes, { enableTracing: false })
        , TableModule
        , HttpClientModule
        , InputTextModule
        , DialogModule
        , ButtonModule
        , CardModule
        , FileUploadModule
        , TabMenuModule
        , DropdownModule
        , TabViewModule
        , ProgressSpinnerModule
        , GalleriaModule
        , TableModule
        , InputSwitchModule
        , ConfirmDialogModule
    ],
    providers: [
        ServicioIndicadorCarga
        , ServicioAlertas
        , SimuladorService
        , MessageService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
